import { useGetMe } from '@/customer/hooks/use-get-me'
import { useListInvoices } from '@/customer/hooks/use-list-invoices'
import { memberCanBookAppointments } from '@/customer/lib/membership'

/**
 * Whether the member satisfies the member-level prerequisites for
 * booking: Stripe account, valid address, verified phone, and no
 * overdue invoices.
 */
export function useMemberBookingGuard(): {
  isPending: boolean
  eligible: boolean
} {
  const me = useGetMe()
  // Invoice fetch failures are deliberately non-blocking; the booking
  // gate is a UX guardrail, not a security boundary, and the server
  // re-validates overdue status on the booking endpoint.
  const { invoices, isPending: invoicesPending } = useListInvoices({ status: 'overdue' })

  if (me.isError) {
    return { isPending: false, eligible: false }
  }

  if (me.isPending || invoicesPending || !me.data) {
    return { isPending: true, eligible: false }
  }

  return {
    isPending: false,
    eligible: memberCanBookAppointments(me.data.member) && !invoices.some((inv) => inv.overdue),
  }
}
